export default __webpack_public_path__ + "static/media/WEG4.599a3c2c.jpg";